import React from "react"
import Header from "./components/Header";
import Footer from "./components/Footer";
import Search from "./components/Search";
import SEO from "./components/SEO";

export default class Index extends React.Component {

  componentDidMount() {
    document.body.classList.add('bg-light');
  }

  render() {
    return (
      <>
        <SEO title={'Início'} />
        <Header />
        <Search />
        <Footer />
      </>
    );
  }
}
